<template lang="pug">
	section(v-bind:class="sectionClass")
		.section-content
			.has-text-centered
				.title.is-spaced
					| {{ $t('home.title2') }}
			.columns.column-text-side
				.column
					p.subtitle.subtitle-right-padding
						| {{ $t('home.content2_l1') }}
				.column
					.gif-workout-container
						img.landscape-phone-gif(src="/img/phone_landscape.png")
						.gif-workout
							img(src="/img/workout-320p.gif")
</template>

<script>
export default {
	name : 'SectionVideo',
	props: {
		num: Number
	},
	computed: {
		sectionClass() {
			return {
				'section'                : true,
				'border-bottom-section'  : true,
				'section-background-grey': this.num % 2 === 0
			}
		}
	},
	methods: {
		openVideoPopup() {
			this.$parent.openVideoPopup()
		}
	}
}
</script>
